import api from './api'

// Профиль видимости: команда и почта Wiseway, от которой она пишет в CRM.
export interface VisibilityProfile {
    id: number
    name: string
    wiseway_email: string
    description: string | null
    is_active: boolean
    member_ids: number[]
    member_names: string[]
    lead_count: number
    // Тёплые и горячие TG-аккаунты профиля. Диалог, который лид начал сам на
    // таком аккаунте, видят только сотрудники профиля и админы.
    account_ids: number[]
    accounts: { id: number; label: string; temperature: string }[]
}

export interface VisibilityProfilePayload {
    name: string
    wiseway_email: string
    description?: string | null
    is_active: boolean
    member_ids?: number[]
    account_ids?: number[]
}

// Подпись профиля: название и почта, без повтора, если название и есть почта
// (так их называет переход на профили).
export function profileLabel(name?: string | null, email?: string | null): string {
    if (!name) return email || ''
    if (!email || name.trim().toLowerCase() === email.trim().toLowerCase()) return name
    return `${name} — ${email}`
}

export const visibilityProfilesApi = {
    list: () => api.get<VisibilityProfile[]>('/visibility-profiles'),
    create: (data: VisibilityProfilePayload) => api.post<VisibilityProfile>('/visibility-profiles', data),
    update: (id: number, data: VisibilityProfilePayload) => api.put<VisibilityProfile>(`/visibility-profiles/${id}`, data),
    remove: (id: number) => api.delete(`/visibility-profiles/${id}`),
}
